export default {
  GET_ITEMS(state) {
    return state.historiqueAbonnements
  },

  GET_ITEM(state, id) {
    return state.historiqueAbonnements.find(item => item.id == id)
  },
}
